var map = {
	"./icon-celular-green-success.svg": "662a",
	"./icon-notebook-green-success.svg": "76bf",
	"./icon-smartwatch-green-success.svg": "afc0",
	"./icon-tablet-green-success.svg": "6474"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11b8";